import { classNames } from "utils/ClassNames"

export type ButtonVariant = "primary" | "secondary" | "danger"
export type ButtonSize = "sm" | "md" | "lg"

const base =
  "inline-flex items-center justify-center rounded-md font-semibold shadow-sm transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-50 disabled:pointer-events-none"

const variantClasses: Record<ButtonVariant, string> = {
  primary:
    "bg-primary-600 text-white hover:bg-primary-500 focus-visible:outline-primary-600",
  secondary:
    "bg-white text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-gray-400 dark:bg-gray-800 dark:text-gray-100 dark:ring-gray-600 dark:hover:bg-gray-700",
  danger: "bg-red-600 text-white hover:bg-red-500 focus-visible:outline-red-600"
}

const sizeClasses: Record<ButtonSize, string> = {
  sm: "px-2.5 py-1.5 text-sm",
  md: "px-3 py-2 text-sm",
  lg: "px-3.5 py-2.5 text-sm"
}

export interface ButtonStyleOptions {
  variant?: ButtonVariant
  size?: ButtonSize
  fullWidth?: boolean
  className?: string
}

/**
 * Builds the Tailwind class string shared by `Button` and `ButtonLink` so a
 * `<button>` and a link styled as a button stay visually identical.
 */
export function buttonClasses({
  variant = "primary",
  size = "md",
  fullWidth = false,
  className
}: ButtonStyleOptions = {}): string {
  return classNames(
    base,
    variantClasses[variant],
    sizeClasses[size],
    fullWidth && "w-full",
    className
  )
}
